export default defineNuxtRouteMiddleware( () => {
  setPageLayout( "my-account" );
} );
